(() => {
  const excluded = 'script,style,textarea,input,code,pre,[contenteditable="true"]';
  const normalize = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (!root.parentElement?.closest(excluded) && /[\u2013\u2014]/.test(root.data)) root.data = root.data.replace(/[\u2013\u2014]/g, '-');
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalize(node);
  };
  normalize(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') normalize(record.target);
      else record.addedNodes.forEach(normalize);
    }
  }).observe(document.body, {subtree:true,childList:true,characterData:true});
})();
